export const
	APP_DOMAIN 			= 'askwise.freecoder.org'

export const
	// The URL of the web pages, to make the frontend routing, i.e. frontend internal links.
	APP_BASE_URL 		= process.env.NODE_ENV === 'production' ? `https://${APP_DOMAIN}` : 'http://localhost:3000',
	WORKERS_BASE_URL	= 'https://askwise.ink',
	LEGACY_WORKERS_BASE_URL=`https://stella.${APP_DOMAIN}`

export const
	// The server API URL.
	API_BASE_URL		= 'https://api.askwise.freecoder.org',
	API_ENDPOINT_URL 	= `${process.env.NODE_ENV == 'production' || RAINDROP_ENVIRONMENT == 'react-native' ? API_BASE_URL : APP_BASE_URL }/v1/`,
	API_RETRIES 		= 3,
	API_TIMEOUT 		= 30000,
	FAVICON_URL 		= `${WORKERS_BASE_URL}/favicon`,
	RENDER_URL 			= `${WORKERS_BASE_URL}/render`,
	PREVIEW_URL			= 'https://preview.systems',
	BETA_AI_URL			= process.env.NODE_ENV == 'production' ? 'https://beta-ai.askwise.freecoder.org/ai' : 'http://localhost:5173/ai'